import Vue from 'vue';

export default {
    buscarOcorrenciasChecklist: () => {
        return Vue.prototype.$http.get('/ocorrencia/problemas-abertos');
    },

    sincronizarManual: () => {
        return Vue.prototype.$http.post('/ocorrencia/sincronizar-manual');
    }
}
